import { formatData } from "./utils";
import { isEmpty } from "lodash";

export function getAllSAV(){
    return async function(dispatch){

        try {
            const response = await fetch('/sav/getAllSAV',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            }); 
            
            const SAVList = await response.json()
            console.log({SAVList})
    
                
            if(SAVList.list){
                console.log('====================================');
                console.log("[INFO] FETCH SAV", SAVList);
                console.log('====================================');
                let SAVSObj = formatData(SAVList.list)
                let newList = {
                    WAITING : {},
                    IN_REPAIR : {},
                    REPAIRED : {},
                    BACK_IN_STOCK : {},
                    HS : {},
                    ALL : SAVSObj,
                }
                console.log({ SAVSObj });
                Object.keys(SAVSObj).map( savID => {
                    console.log('====================================');
                    console.log({savID, SAVSObj});
                    console.log('====================================');
                    let sav_status = SAVSObj[savID].sav_last_status
                    
                    newList[sav_status][savID] = SAVSObj[savID]
                })
                // newList.ALL = !isEmpty(newList.ALL) && sortByDate(Object.values(newList.ALL))
                // newList.WAITING = !isEmpty(newList.WAITING) && sortByDate(Object.values(newList.WAITING))
                // newList.IN_REPAIR = !isEmpty(newList.IN_REPAIR) && sortByDate(Object.values(newList.IN_REPAIR))
                // newList.REPAIRED = !isEmpty(newList.REPAIRED) && sortByDate(Object.values(newList.REPAIRED))
                // newList.BACK_IN_STOCK = !isEmpty(newList.BACK_IN_STOCK) && sortByDate(Object.values(newList.BACK_IN_STOCK))
            
                dispatch({
                    type: "GET_SAVS",
                    payload: newList
                })
            } else {

                console.log('====================================');
                console.log("[ERROR] FETCH SAV", {SAVList});
                console.log('====================================');
            }
            
            
        } catch (err) {
            console.log('====================================');
            console.log("[ERROR] FETCH ALL SAV", err);
            console.log('====================================');
            return err
        }
    }
        
}
export function updateActions(savID){
    return async function(dispatch){

        try {
            const response = await fetch('/sav/getActions',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({data: savID}),
                credentials: 'same-origin',
            }); 
            
            const actionList = await response.json()
            console.log({actionList})
    
            if(actionList.list){
                
            
                dispatch({
                    type: "UPDATE_ACTION",
                    payload: actionList
                })
            } else {

                console.log('====================================');
                console.log("[ERROR] FETCH SAV", actionList);
                console.log('====================================');
            }
            
            
        } catch (err) {
            console.log('====================================');
            console.log("[ERROR] FETCH update SAV", err);
            console.log('====================================');
            return err
        }
    }
        
}
// export function addInSav(sav){
//     return async function(dispatch){
//         try {
//             const response = await fetch('/sav/getSAV',{
//                 method:'POST',
//                 headers: { 
//                     'Content-Type': 'application/json',
//                     //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
//                 },
//                 body:JSON.stringify({data: sav.id}),
//                 credentials: 'same-origin',
//             }); 
            
//             const updated_sav = await response.json()
//             console.log({updated_sav})
    
//             if(updated_sav.list){
//                 dispatch({
//                     type: "ADD_SAV",
//                     payload: updated_sav.list
//                 })
//             } else {
//                 console.log('====================================');
//                 console.log("[ERROR] FETCH SAV", updated_sav);
//                 console.log('====================================');
//             }
            
//         } catch (err) {
//             console.log('====================================');
//             console.log("[ERROR] FETCH SAV", err);
//             console.log('====================================');
//             return err
//         }
//     }
        
// }
export function updateSav(sav){
    return async function(dispatch){
        console.log('====================================');
        console.log("updateSAV act", {sav});
        console.log('====================================');
        let oldStatus = sav.sav_last_status
        try {
            const response = await fetch('/sav/getSAV',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({data: sav.id}),
                credentials: 'same-origin',
            }); 
            
            const updated_sav = await response.json()
            console.log({updated_sav})
    
            if(updated_sav.list){
                dispatch({
                    type: "UPDATE_SAV",
                    payload: {oldStatus, sav:updated_sav.list}
                })
            } else {
                console.log('====================================');
                console.log("[ERROR] FETCH SAV", updated_sav);
                console.log('====================================');
            }
            
        } catch (err) {
            console.log('====================================');
            console.log("[ERROR] FETCH update 2 SAV", err);
            console.log('====================================');
            return err
        }
    }
        
}